var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ReportingSettingsManagementApi_1;
import { HarriAPI, harriApi } from "@core/apis/HarriAPI";
export var LOCATION_FILTER_TYPE;
(function (LOCATION_FILTER_TYPE) {
    LOCATION_FILTER_TYPE["ALL_LEVELS"] = "ALL_LEVELS";
    LOCATION_FILTER_TYPE["CHILDREN_ONLY"] = "CHILDREN_ONLY";
})(LOCATION_FILTER_TYPE || (LOCATION_FILTER_TYPE = {}));
let ReportingSettingsManagementApi = ReportingSettingsManagementApi_1 = class ReportingSettingsManagementApi extends HarriAPI {
    static async getServiceSettings(brandId, serviceCode) {
        const endPoint = `brands/${brandId}/services/${serviceCode}/reporting_settings`;
        const response = await ReportingSettingsManagementApi_1.request(endPoint, 'GET');
        if (response?.data?.data) {
            return response.data.data;
        }
        throw response;
    }
};
ReportingSettingsManagementApi = ReportingSettingsManagementApi_1 = __decorate([
    harriApi({ teamlive: "ReportingSettingsManagement" /* ENDPOINT.REPORTING_SETTINGS_MANAGEMENT */, harri: "ReportingSettingsManagement" /* ENDPOINT.REPORTING_SETTINGS_MANAGEMENT */ })
], ReportingSettingsManagementApi);
export { ReportingSettingsManagementApi };
//# sourceMappingURL=reporting-settings-management.api.js.map